// Release notes, newest first. Shown in About (behind the ⓘ) and, later, used
// to decide whether to surface a quiet "what's new" note after an update.
// Keep entries in plain, non-technical language.
export const CHANGELOG = [
  {
    version: '0.4.0',
    title: 'A little more to sit with',
    notes: [
      'Every landing word now has an optional, gentle note — what the feeling often points to, and one small thing you might do — tucked behind a tap, never in the way. A note to sit with, not advice.',
      'The body check-in now says what each signal can feel like, so it’s easier to recognise what you’re noticing.',
      'In “pick the words that fit”, the summary category now opens that feeling’s own page — so there’s somewhere to go after tracing inward, just like the words themselves.',
    ],
  },
  {
    version: '0.3.1',
    title: 'A gentle bridge from body to feelings',
    notes: [
      'After a body check-in, there’s now an optional step to put words to how you’re feeling — it just opens the Feelings tool, and never assumes what a body signal means.',
    ],
  },
  {
    version: '0.3.0',
    title: 'Easier to find the right word',
    notes: [
      'Search now forgives typos — a slipped letter still finds the feeling.',
      'Many more everyday words lead to the right feeling, so you can type it the way you’d say it.',
      'The feelings you looked at recently show up on the Feelings screen for quick return — kept only while the app is open, never saved.',
    ],
  },
  {
    version: '0.2.0',
    title: 'Added the Body check-in',
    notes: [
      'New tool: a calm body check-in (interoception) that helps you notice hunger, thirst, tiredness, tension, overstimulation and more — and what your body might be asking for.',
      'A home screen for the toolbox; more tools can be added over time.',
      'Settings, backups and history are shared across all tools.',
    ],
  },
  {
    version: '0.1.0',
    title: 'First working version',
    notes: [
      'Find a feeling three ways: start from a core feeling, pick the words that fit, or search.',
      'Plain-language definition and nearby words on every feeling.',
      'Calm settings: match system, dark, or monochrome; larger text, reduced motion, high contrast, low-stimulation layout.',
      'Your data stays on your device. Export a backup anytime; backups are never changed once saved.',
    ],
  },
];
